<template>
  <div id="general-company-info" class="component">
    <!-- <form-status :v="$v" /> -->
    <form submit.prevent novalidate method="post" enctype="multipart/form-data">
      <!-- Agreement Number -->
      <div class="form-group row">
        <label for="requestorEmail" class="col-md-12 control-label required">
          Please enter Agreement Number:
          <tooltip :content="renewalNoDesc" effect="scale" placement="right"
            ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
        <div class="col-md-12">
          <input
            v-model="modifyAgreement.renewalNo"
            type="email"
            class="form-control"
            @blur="$v.modifyAgreement.renewalNo.$touch()"
          />
        </div>
        <div
          v-if="!$v.modifyAgreement.renewalNo.required && $v.modifyAgreement.renewalNo.$error"
          class="col-md-12 text-danger"
        >
          Please enter Agreement number.
        </div>
        <div
          v-if="!$v.modifyAgreement.renewalNo.maxLength && $v.modifyAgreement.renewalNo.$error"
          class="col-md-12 text-danger"
        >
          Allowed upto 50 characters only.
        </div>
      </div>
      <!-- Requestor Email Address -->
      <div class="form-group row">
        <label for="requestorEmail" class="col-md-12 control-label required">
          Please enter your e-mail address:
        </label>
        <div class="col-md-12">
          <input
            v-model="modifyAgreement.requestorEmail"
            type="email"
            class="form-control"
            @blur="$v.modifyAgreement.requestorEmail.$touch()"
          />
        </div>
        <div
          v-if="!$v.modifyAgreement.requestorEmail.required && $v.modifyAgreement.requestorEmail.$error"
          class="col-md-12 text-danger"
        >
          Please enter email address.
        </div>
        <div
          v-if="!$v.modifyAgreement.requestorEmail.maxLength && $v.modifyAgreement.requestorEmail.$error"
          class="col-md-12 text-danger"
        >
          Allowed upto 150 characters only.
        </div>
        <div
          v-if="!$v.modifyAgreement.requestorEmail.email && $v.modifyAgreement.requestorEmail.$error"
          class="col-md-12 text-danger"
        >
          Please enter a valid email address.
        </div>
      </div>
      <!-- Requestor Phone Number -->
      <div class="form-group row">
        <label for="requestorPhNo" class="col-md-12 control-label required">
          Please enter your phone number:
        </label>
        <div class="col-md-12">
          <input
            v-model="modifyAgreement.requestorPh"
            type="text"
            class="form-control"
            @blur="$v.modifyAgreement.requestorPh.$touch()"
          />
        </div>
        <div
          v-if="!$v.modifyAgreement.requestorPh.required && $v.modifyAgreement.requestorPh.$error"
          class="col-md-12 text-danger"
        >
          Please enter phone number.
        </div>
        <div
          v-if="!$v.modifyAgreement.requestorPh.isNumber && $v.modifyAgreement.requestorPh.$error"
          class="col-md-12 text-danger"
        >
          Please enter valid phone number.
        </div>
        <div
          v-if="!$v.modifyAgreement.requestorPh.maxLength && $v.modifyAgreement.requestorPh.$error"
          class="col-md-12 text-danger"
        >
          Allowed upto 15 characters only.
        </div>
      </div>
      <!-- Primary Representation contact fields -->
      <div class="form-group row">
        <label for="primaryContactChgFlg" class="col-md-12 control-label required">
          Are you still the primary person to represent your company for this agreement?
          <tooltip :content="primaryContactChgFlgDesc" effect="scale" placement="right"
            ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
        <div class="col-md-12 form-group">
          <label class="radio-inline">
            <input v-model="modifyAgreement.primaryContactChgFlg" type="radio" :value="false" />Yes
          </label>
          <label class="radio-inline">
            <input v-model="modifyAgreement.primaryContactChgFlg" type="radio" :value="true" />No
          </label>
        </div>
        <div v-if="modifyAgreement.primaryContactChgFlg">
          <div class="form-group">
            <label for="contactName" class="col-md-12 control-label">
              Name:
            </label>
            <div class="col-md-2 form-group">
              <input
                v-model="modifyAgreement.contactName"
                type="text"
                class="form-control"
                @blur="$v.modifyAgreement.contactName.$touch()"
              />
              <div
                v-if="!$v.modifyAgreement.contactName.required && $v.modifyAgreement.contactName.$error"
                class="text-danger"
              >
                Please enter Contact Name.
              </div>
              <div
                v-if="!$v.modifyAgreement.contactName.maxLength && $v.modifyAgreement.contactName.$error"
                class="text-danger"
              >
                Allowed upto 50 characters only.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="contactPh" class="col-md-12 control-label">
              Phone:
            </label>
            <div class="col-md-2 form-group">
              <input
                v-model="modifyAgreement.contactPh"
                type="text"
                class="form-control"
                @blur="$v.modifyAgreement.contactPh.$touch()"
              />
              <div
                v-if="!$v.modifyAgreement.contactPh.required && $v.modifyAgreement.contactPh.$error"
                class="text-danger"
              >
                Please enter Phone Number.
              </div>
              <div
                v-if="!$v.modifyAgreement.contactPh.isNumber && $v.modifyAgreement.contactPh.$error"
                class="text-danger"
              >
                Please enter valid Phone Number.
              </div>
              <div
                v-if="!$v.modifyAgreement.contactPh.maxLength && $v.modifyAgreement.contactPh.$error"
                class="text-danger"
              >
                Allowed upto 15 characters only.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="contactEmail" class="col-md-12 control-label">
              Email:
            </label>
            <div class="col-md-2 form-group">
              <input
                v-model="modifyAgreement.contactEmail"
                type="text"
                class="form-control"
                @blur="$v.modifyAgreement.contactEmail.$touch()"
              />
              <div
                v-if="!$v.modifyAgreement.contactEmail.required && $v.modifyAgreement.contactEmail.$error"
                class="text-danger"
              >
                Please enter Email Address.
              </div>
              <div
                v-if="!$v.modifyAgreement.contactEmail.email && $v.modifyAgreement.contactEmail.$error"
                class="text-danger"
              >
                Please enter valid Email Address.
              </div>
              <div
                v-if="!$v.modifyAgreement.contactEmail.maxLength && $v.modifyAgreement.contactEmail.$error"
                class="text-danger"
              >
                Allowed upto 150 characters only.
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Company Legal Name adress fields -->
      <div class="form-group row">
        <label for="cmpnyNameChgFlg" class="col-md-12 control-label required">
          Has your company name or address changed?
        </label>
        <div class="col-md-12">
          <label class="radio-inline">
            <input v-model="modifyAgreement.cmpnyNameChgFlg" type="radio" :value="true" />Yes
          </label>
          <label class="radio-inline">
            <input v-model="modifyAgreement.cmpnyNameChgFlg" type="radio" :value="false" />No
          </label>
        </div>
        <div v-if="modifyAgreement.cmpnyNameChgFlg" class="fieldBundle form-group">
          <div class="form-group">
            <label for="cmpnyName" class="col-md-12 control-label require">
              Full Legal Company Name:
            </label>
            <div class="col-md-12 form-group">
              <input
                v-model="modifyAgreement.cmpnyName"
                type="text"
                class="form-control"
                @blur="$v.modifyAgreement.cmpnyName.$touch()"
              />
              <div
                v-if="!$v.modifyAgreement.cmpnyName.required && $v.modifyAgreement.cmpnyName.$error"
                class="text-danger"
              >
                Please enter Full Legal Company Name.
              </div>
              <div
                v-if="!$v.modifyAgreement.cmpnyName.maxLength && $v.modifyAgreement.cmpnyName.$error"
                class="text-danger"
              >
                Allowed upto 50 characters only.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="cmpnyFullAddr" class="col-md-12 control-label require">
              Full Address including country:
            </label>
            <div class="col-md-12 form-group">
              <input
                v-model="modifyAgreement.cmpnyFullAddr"
                type="text"
                class="form-control"
                @blur="$v.modifyAgreement.cmpnyFullAddr.$touch()"
              />
              <div
                v-if="!$v.modifyAgreement.cmpnyFullAddr.required && $v.modifyAgreement.cmpnyFullAddr.$error"
                class="text-danger"
              >
                Please enter Full Address including country.
              </div>
              <div
                v-if="!$v.modifyAgreement.cmpnyFullAddr.maxLength && $v.modifyAgreement.cmpnyFullAddr.$error"
                class="text-danger"
              >
                Allowed upto 500 characters only.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="cmpnyNameChgFlgDesc" class="col-md-12 control-label require">
              Name or Address change documentation:
              <tooltip :content="cmpnyNameChgFlgDesc" effect="scale" placement="right"
                ><i class="fa fa-question-circle"></i>
              </tooltip>
            </label>
            <div class="col-md-12">
              <file-upload
                upload-section="sfgtaGeneralInfo"
                document-type="NameAddressChangeDoc"
                :document-name="nameAddressChangeDoc"
                document-status="add"
                :v="$v.nameAddressChangeDoc"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Additional Engine model Description fields -->
      <div class="form-group row">
        <label for="engMdlChgFlg" class="control-label col-md-12 required">
          Do you need to add or remove any engine models from your current agreement?
        </label>
        <div class="col-md-12 form-group">
          <label class="radio-inline">
            <input v-model="modifyAgreement.engMdlChgFlg" type="radio" :value="true" />Yes
          </label>
          <label class="radio-inline">
            <input v-model="modifyAgreement.engMdlChgFlg" type="radio" :value="false" />No
          </label>
        </div>
        <div v-if="modifyAgreement.engMdlChgFlg" class="col-md-12 form-group">
          <textarea
            v-model.trim="modifyAgreement.engMdlDesc"
            type="text"
            class="form-control"
            autocomplete="no"
            placeholder="Please describe them here."
            @blur="$v.modifyAgreement.engMdlDesc.$touch()"
          >
          </textarea>
          <div
            v-if="!$v.modifyAgreement.engMdlDesc.required && $v.modifyAgreement.engMdlDesc.$error"
            class="text-danger"
          >
            Please enter valid description.
          </div>
          <div
            v-if="!$v.modifyAgreement.engMdlDesc.maxLength && $v.modifyAgreement.engMdlDesc.$error"
            class="text-danger"
          >
            Allowed upto 500 characters only.
          </div>
        </div>
      </div>
      <!-- Any other changes flag/description fields -->
      <div class="form-group row">
        <label for="anyOtherChgFlg" class="control-label col-md-12 required">
          Are there any modification or changes that are required for your current agreement?
        </label>
        <div class="col-md-12 form-group">
          <label class="radio-inline">
            <input v-model="modifyAgreement.anyOtherChgFlg" type="radio" :value="true" />Yes
          </label>
          <label class="radio-inline">
            <input v-model="modifyAgreement.anyOtherChgFlg" type="radio" :value="false" />No
          </label>
        </div>
        <div v-if="modifyAgreement.anyOtherChgFlg" class="col-md-12 form-group">
          <textarea
            v-model.trim="modifyAgreement.anyOtherChgDesc"
            type="text"
            class="form-control"
            autocomplete="no"
            placeholder="Please describe them here."
            @blur="$v.modifyAgreement.anyOtherChgDesc.$touch()"
          >
          </textarea>
          <div
            v-if="!$v.modifyAgreement.anyOtherChgDesc.required && $v.modifyAgreement.anyOtherChgDesc.$error"
            class="text-danger"
          >
            Please enter valid description.
          </div>
          <div
            v-if="!$v.modifyAgreement.anyOtherChgDesc.maxLength && $v.modifyAgreement.anyOtherChgDesc.$error"
            class="text-danger"
          >
            Allowed upto 500 characters only.
          </div>
        </div>
      </div>
      <!-- Airworthiness Authority Documentation document -->
      <div class="form-group row">
        <label for="airwothyDoc" class="control-label col-md-12"
          >Airworthiness Authority Documentation:
          <tooltip :content="airwothyDocDesc" effect="scale" placement="right"
            ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
        <div class="col-md-12">
          <file-upload
            upload-section="sfgtaGeneralInfo"
            document-type="airwothyDoc"
            :document-name="airwothyDocName"
            document-status="add"
          />
        </div>
      </div>
      <!-- Aircraft Lessors document -->
      <div class="form-group row">
        <label for="aircraftLessorsDoc" class="control-label col-md-12"
          >Aircraft Lessors:
          <tooltip :content="aircraftLessorsDocDesc" effect="scale" placement="right"
            ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
        <div class="col-md-12">
          <file-upload
            upload-section="sfgtaGeneralInfo"
            document-type="aircraftLessorsDoc"
            :document-name="aircraftLessorsDocName"
            document-status="add"
          />
        </div>
      </div>
      <!-- Asset Manager document -->
      <div class="form-group row">
        <label for="assetManagerDoc" class="control-label col-md-12"
          >Asset Managers:
          <tooltip :content="assetManagerDocDesc" effect="scale" placement="right"
            ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
        <div class="col-md-12">
          <file-upload
            upload-section="sfgtaGeneralInfo"
            document-type="assetManagerDoc"
            :document-name="assetManagerDocName"
            document-status="add"
          />
        </div>
      </div>
      <!-- Data Protection Plan document -->
      <div class="form-group row">
        <label for="dppDoc" class="control-label col-md-12"
          >Data Protection Plan:
          <tooltip :content="dppDocDesc" effect="scale" placement="right"
            ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
        <div class="col-md-12">
          <file-upload
            upload-section="sfgtaGeneralInfo"
            document-type="dppDoc"
            :document-name="dppDocName"
            document-status="add"
          />
        </div>
      </div>
      <!-- Updated Contact List document -->
      <div class="form-group row">
        <label for="UpdatedContListDesc" class="control-label col-md-12"
          >Updated Contact List:
          <tooltip :content="UpdatedContListDesc" effect="scale" placement="right"
            ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
        <div class="col-md-12">
          <file-upload
            upload-section="sfgtaGeneralInfo"
            document-type="updatedContList"
            :document-name="updatedContListName"
            document-status="add"
          />
        </div>
      </div>
      <!-- Attention Note -->
      <div class="form-group row">
        <div class="col-md-12">
          <p>
            Attention: please note that this information is required in order to prepare an updated agreement and
            prevent any interruption of your support. An updated agreement document will be created and sent to you for
            your signature.
          </p>
        </div>
      </div>
      <!-- Action Buttons -->
      <div class="action-btns">
        <input type="button" class="btn btn-sm btn-default" value="Cancel" @click.prevent="gotToHome()" />
        <input type="submit" class="btn btn-sm btn-primary" value="Submit" @click.prevent="displayRecaptcha()" />
        <!-- <strong v-if="formErrorMsg" class="text-danger">Please fill all required fields to proceed further.</strong> -->
      </div>
      <!-- Recaptcha BOT -->
      <div>
        <BotControlAOB
          :display-data="showRecaptcha"
          @closeModal="showRecaptcha = false"
          @recaptchaResponseData="submitSfgtaForm"
        />
      </div>
    </form>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fileUpload from "@/common/components/new-company/FileUpload";
import tooltip from "build-ui-x/src/Tooltip";
import { email, required, requiredIf, maxLength } from "vuelidate/lib/validators";
import BotControlAOB from "@/common/components/new-company/BotControlAOB";

const isNumber = function(value) {
  var validRegex = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/; // eslint-disable-line
  return validRegex.test(value);
};

export default {
  components: {
    fileUpload,
    tooltip,
    BotControlAOB
  },
  data() {
    return {
      showRecaptcha: false
    };
  },
  computed: {
    ...mapState("modifyAgreement", ["modifyAgreement"]),
    renewalNoDesc() {
      return "This number can be found on your Short Form GTA that was previously provided once your original agreement was finalized.";
    },
    cmpnyNameChgFlgDesc() {
      return "Please attach a letter on company letterhead or other formal documentation that supports the name or address change.";
    },
    primaryContactChgFlgDesc() {
      return "Current contact information is critical to ensure there is no interruption to products, services, and support if we need to contact your company due to a contract-related issue or agreement expiration.";
    },
    airwothyDocDesc() {
      return "Please attach your current Air Operator's Certificate, Ops Specifications, Ratings and Limitations, and Capabilities List (or equivalent paperwork) here.";
    },
    dppDocDesc() {
      return "Please attach your company's Data Protection Plan here. In the document, describe the measures in place at your company to protect data to be shared under this agreement.";
    },
    UpdatedContListDesc() {
      return "Please update the Contacts List excel file sent with your notification email and attach here. Please remove any employees who are no longer with the company, and adding additional employees if needed.";
    },
    aircraftLessorsDocDesc() {
      return "Please attach a summary of your fleet (aircraft serial number, tail numbers, engine serial numbers) and appropriate Bill of Sale documentation here.";
    },
    assetManagerDocDesc() {
      return "Please attach a document that establishes the relationship between the aircraft owner and asset manager, as well as the letter of authorization from the aircraft owner which desginates the asset manager as authorized to manage asset on behalf of the aircraft owner.";
    },
    nameAddressChangeDoc() {
      let plaDocs = this.modifyAgreement.documents;
      let docName = "";
      for (let i = 0; i < plaDocs.length; i++) {
        if (plaDocs[i].documentType == "NameAddressChangeDoc") {
          docName = plaDocs[i].documentName;
          break;
        }
      }
      return docName;
    },
    airwothyDocName() {
      let plaDocs = this.modifyAgreement.documents;
      let docName = "";
      for (let i = 0; i < plaDocs.length; i++) {
        if (plaDocs[i].documentType == "airwothyDoc") {
          docName = plaDocs[i].documentName;
          break;
        }
      }
      return docName;
    },
    aircraftLessorsDocName() {
      let plaDocs = this.modifyAgreement.documents;
      let docName = "";
      for (let i = 0; i < plaDocs.length; i++) {
        if (plaDocs[i].documentType == "aircraftLessorsDoc") {
          docName = plaDocs[i].documentName;
          break;
        }
      }
      return docName;
    },
    assetManagerDocName() {
      let plaDocs = this.modifyAgreement.documents;
      let docName = "";
      for (let i = 0; i < plaDocs.length; i++) {
        if (plaDocs[i].documentType == "assetManagerDoc") {
          docName = plaDocs[i].documentName;
          break;
        }
      }
      return docName;
    },
    dppDocName() {
      let plaDocs = this.modifyAgreement.documents;
      let docName = "";
      for (let i = 0; i < plaDocs.length; i++) {
        if (plaDocs[i].documentType == "dppDoc") {
          docName = plaDocs[i].documentName;
          break;
        }
      }
      return docName;
    },
    updatedContListName() {
      let plaDocs = this.modifyAgreement.documents;
      let docName = "";
      for (let i = 0; i < plaDocs.length; i++) {
        if (plaDocs[i].documentType == "updatedContList") {
          docName = plaDocs[i].documentName;
          break;
        }
      }
      return docName;
    }
  },
  watch: {
    "modifyAgreement.cmpnyNameChgFlg": function(newVal) {
      if (newVal) {
        this.$v.modifyAgreement.cmpnyName.$reset();
        this.$v.modifyAgreement.cmpnyFullAddr.$reset();
        this.$v.nameAddressChangeDoc.$reset();
      } else {
        //clearing the store
        this.$store.dispatch("modifyAgreement/clearNameAddress");
        //clearing the document from both files store as well as meta data if there is any
        let doc = {
          uploadSection: "sfgtaGeneralInfo",
          productType: "",
          documentType: "NameAddressChangeDoc"
        };
        this.$store.dispatch("modifyAgreement/removePlaFileMetaData", doc);
        this.$store.dispatch("files/removeFile", doc.documentType);
      }
    },
    "modifyAgreement.primaryContactChgFlg": function(newVal) {
      if (newVal) {
        this.$v.modifyAgreement.contactName.$reset();
        this.$v.modifyAgreement.contactPh.$reset();
        this.$v.modifyAgreement.contactEmail.$reset();
      } else {
        this.$store.dispatch("modifyAgreement/clearContactDetails");
      }
    },
    "modifyAgreement.engMdlChgFlg": function(newVal) {
      if (newVal) {
        this.$v.modifyAgreement.engMdlDesc.$reset();
      } else {
        this.$store.dispatch("modifyAgreement/clearEngMdlDesc");
      }
    },
    "modifyAgreement.anyOtherChgFlg": function(newVal) {
      if (newVal) {
        this.$v.modifyAgreement.anyOtherChgDesc.$reset();
      } else {
        this.$store.dispatch("modifyAgreement/clearAnyOtherChgDesc");
      }
    }
  },
  validations: {
    modifyAgreement: {
      renewalNo: {
        required,
        maxLength: maxLength(50)
      },
      requestorEmail: {
        required,
        email,
        maxLength: maxLength(150)
      },
      requestorPh: {
        required,
        isNumber,
        maxLength: maxLength(15)
      },
      cmpnyName: {
        required: requiredIf(function() {
          return this.modifyAgreement.cmpnyNameChgFlg;
        }),
        maxLength: maxLength(50)
      },
      cmpnyFullAddr: {
        required: requiredIf(function() {
          return this.modifyAgreement.cmpnyNameChgFlg;
        }),
        maxLength: maxLength(500)
      },
      contactName: {
        required: requiredIf(function() {
          return this.modifyAgreement.primaryContactChgFlg;
        }),
        maxLength: maxLength(50)
      },
      contactPh: {
        required: requiredIf(function() {
          return this.modifyAgreement.primaryContactChgFlg;
        }),
        isNumber,
        maxLength: maxLength(15)
      },
      contactEmail: {
        email,
        required: requiredIf(function() {
          return this.modifyAgreement.primaryContactChgFlg;
        }),
        maxLength: maxLength(150)
      },
      engMdlDesc: {
        required: requiredIf(function() {
          return this.modifyAgreement.engMdlChgFlg;
        }),
        maxLength: maxLength(500)
      },
      anyOtherChgDesc: {
        required: requiredIf(function() {
          return this.modifyAgreement.anyOtherChgFlg;
        }),
        maxLength: maxLength(500)
      }
    },
    nameAddressChangeDoc: {
      required: requiredIf(function() {
        return this.modifyAgreement.cmpnyNameChgFlg;
      })
    }
  },
  methods: {
    gotToHome() {
      this.$router.push("/sfgta-agreement");
      window.location.reload();
    },
    displayRecaptcha() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$store.dispatch("user/setEmail", this.modifyAgreement.requestorEmail);
      this.showRecaptcha = true;
      if (window.grecaptcha) {
        window.grecaptcha.reset();
      }
    },
    submitSfgtaForm(recaptchaData) {
      this.$emit("submitSFGTA", recaptchaData);
    }
  }
};
</script>
<style lang="less" scoped>
.form-control {
  max-width: 300px;
}
.action-btns {
  margin-top: 0;
}
#product-type-info {
  width: 200px;
}
#product-type {
  padding-left: 10px;
  label {
    font-weight: normal;
  }
}
#military-warning-message {
  margin-top: 20px;
  color: blue;
}
#legal-name {
  width: 70px;
}

.fieldBundle {
  margin-top: 4%;
}
</style>
